import { GoalReviewStatus, GoalStatus, LineChartOptions } from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const goalReportsTranslations = {
  // statuses
  [GoalStatus.inProgress]: 'In Progress',
  [GoalStatus.done]: 'Completed',
  [GoalStatus.notStarted]: 'Not Started',
  [GoalStatus.paused]: 'Paused',
  [GoalStatus.archive]: 'Archived',

  [GoalReviewStatus.overdue]: 'Overdue',
  [GoalReviewStatus.dueToday]: 'Due today',
  [GoalReviewStatus.dueTomorrow]: 'Due tomorrow',
  [GoalReviewStatus.dueThisWeek]: 'Due this week',

  FILTER_RESIDENTS: 'Residents',
  FILTER_STATUS: 'Goals status',
  NO_FILTERS: 'No filters applied',
  FILTERED_BY: 'Filtered by',
  AND_BY: 'AND by',
  STATUS: 'Goals status',
  REVIEW_STATUS: 'Review status',
  GOAL_MANAGEMENT: 'Goals Management',
  GOAL_STATUS: 'Goal Status',
  EMAIL_SENT_TOAST_1: 'An email with the CSV will be sent to',
  EMAIL_SENT_TOAST_2: 'At peak times this may take a while',
  DOWNLOADING: 'Downloading...',
  EXPORT_CSV: 'Download CSV',
  EMPTY_STATE: 'Shoot... no data to show you',
  GO_TO_GOALS_DASHBOARD: 'Go to goals dashboard',
  ADD_A_GOAL_HERE: 'Add a goal here',

  // Goals Dashboard
  GOALS_DASHBOARD: 'Goals Dashboard',
  DOWNLOAD_PDF: 'Download PDF',
  SITE: 'Site',
  FILTER_DATE: 'Date',
  FILTER_RESIDENT: 'Resident',
  GOAL_STATUS_DESCRIPTION: 'All goal statuses in this timeframe',
  GOAL_STATISTICS: 'Goal Statistics',
  GOAL_STATISTICS_DESCRIPTION:
    'Data collected from all goals in this timeframe',
  AVERAGE_PROGRESS: 'Average (%) of progress added per goal',
  TOTAL_MILESTONES_COMPLETED: 'Total number of milestones completed',
  AVERAGE_LOGS: 'Average logs per goal',
  GOAL_IN_PROGRESS: '{{preferredTerm}} with a goal in progress',
  GOAL_OVERDUE: '{{preferredTerm}} with overdue goals',
  RESULTS: 'Results',
  PERCENTAGE_ADDED: 'Percentage added',
  PERCENTAGE_ADDED_DESCRIPTION: 'The amount of progress added in (%) per month',
  LOGS_LINKED: 'Logs linked',
  LOGS_LINKED_DESCRIPTION: 'The number of logs linked per month',
  GOALS_COMPLETED: 'Goals completed',
  TIME: 'Time',
  LOGS: 'Logs',
  PERCENTAGE: 'Percentage (%)',
  [LineChartOptions?.GoalsCompleted]: 'Goals completed',
  [LineChartOptions?.AverageProgressAdded]: 'Average progress added',
  [LineChartOptions?.TotalLogsLinked]: 'Total logs linked',

  // Group dashboard
  FILTER_SITE: 'Site',
  INDIVIDUALS: 'Individuals'
}

export const goalReportsConstants = getKeys(goalReportsTranslations)
